import Cookies from 'js-cookie'

const tokenKey = process.env.VUE_APP_TOKEN_KEY || 'edu_token'
const mainSite = process.env.VUE_APP_MAIN_SITE

export function getToken() {
  return Cookies.get(tokenKey)
}

export function setToken(token, needSave) {
  const config = {}
  if (needSave) {
    config.expires = 30
  }

  if (mainSite) {
    config.domain = mainSite
  }
  return Cookies.set(tokenKey, token, config)
}

export function removeToken() {
  if (mainSite) {
    Cookies.remove(tokenKey, { domain: mainSite })
  }
  return Cookies.remove(tokenKey)
}
